import { Outlet } from "react-router-dom";

const FruitPage = () => {
    return (
        <Outlet />
    );
};

export default FruitPage;
